import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useStickyRail = (
  railRef: RefObject<HTMLElement | null>,
  slotRef: RefObject<HTMLElement | null>,
  enabled: boolean
) => {
  useEffect(() => {
    if (!enabled) return;
    const slot = slotRef.current;
    const rail = railRef.current;
    if (!slot || !rail) return;

    const measure = () => {
      const box = slot.getBoundingClientRect();
      rail.style.top = `${box.top + window.scrollY}px`;
      rail.style.left = `${box.left + window.scrollX}px`;
      rail.style.width = `${box.width}px`;
    };
    measure();
    document.fonts?.ready.then(measure).catch(() => {});

    const observer = new ResizeObserver(measure);
    observer.observe(slot);
    observer.observe(document.body);
    return () => observer.disconnect();
  }, [railRef, slotRef, enabled]);
};
